import styled from 'styled-components';
import {
  typography,
  size,
  mediaQueries,
  Button as RawButton,
  Modal as RawModal,
} from '@everlywell/leaves';

const Modal = styled(RawModal)`
  ${mediaQueries.forTabletHorizontalUp} {
    width: 650px;
  }
`;

const Title = styled.h2`
  ${typography.h2Text};
  margin-bottom: ${size.lg}px;
  text-align: center;
`;

const Copy = styled.p`
  ${typography.bodyText};
  margin-bottom: ${size.xl3}px;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Button = styled(RawButton)`
  flex: 1 1 100%;
  margin-bottom: ${size.lg}px;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 0;
    flex: 0 0 48%;
  }
`;

export { Modal, Title, Copy, ButtonContainer, Button };
